import { Button, Icon, message, Row, Typography, Upload, Select } from "antd";
import { ReactComponent as Logoo } from "./Svgs/Translation.svg";
import React, { useState } from 'react'
import Dragger from "antd/lib/upload/Dragger";
import { importLanguageDataApi } from "utils/apiService";
const { Text } = Typography;

export default function ImportFileModalContent(props) {
    const { closeModal } = props;
    const [StoreImageFile, setStoreImageFile] = useState(null);
    const [languageImportFile, setLanguageImportFile] = useState(null);

    const addLanguage = () => {
        message.info("Creating cohorts please wait...");
        let formData = new FormData();
        if (languageImportFile) {
            formData.append("file", languageImportFile);
            formData.append("permission_category", JSON.stringify(["USER_ADMINISTRATION"]));
            importLanguageDataApi({
                requestData: formData,
                resCallback: () => { },
                res200Callback: () => {
                    message.success("Language file imported successfully.");
                    closeModal()
                    // loadTable();
                    // setImportModal(false);
                },
                resErrorCallback: () => {
                    message.error("Failed importing the Language file!");
                },
            });
        }
    };

    return (
        <div>
            <Row className="modal-row">
                <Row>
                    <div style={{ display: "flex" }}>
                        <div>
                            <Logoo style={{ marginTop: "2px" }} />
                        </div>
                        <Text
                            style={{
                                marginLeft: "16px",
                                fontWeight: "700",
                                color: "#181818",
                                fontSize: "24px",
                                fontStyle: "normal",
                                lineHeight: "40px",
                            }}>
                            Import Language File
                        </Text>
                    </div>
                </Row>
                <div style={{ margin: "16px 0px", background: "#E8E8E8", height: "1px" }}></div>
                <Row
                    className="stores_wrapper" >
                    <div>
                        <Row className="image-upload-row" >
                            <React.Fragment>
                                <div className="image-upload-col" style={{ padding: "0" }}>
                                    <Row type="flex" align="middle" justify="space-between" style={{ marginTop: "10px" }}>
                                        <Text
                                            style={{
                                                fontSize: "14px",
                                                color: "#181818",
                                                fontWeight: "bold",
                                            }}>
                                            Upload Language List
                                        </Text>
                                        <a
                                            href="http://s3-eu-central-1.amazonaws.com/inaam-app/sample_files/Cohort_Sample_File.xlsx"
                                            download
                                            style={{
                                                color: "#fec708",
                                                fontStyle: "normal",
                                                fontWeight: "normal",
                                                fontSize: "12px",
                                                lineHeight: "18px",
                                            }}>
                                            <Icon type="download" style={{ marginRight: "8px" }} />
                                            Download Sample File
                                        </a>
                                    </Row>

                                    <Dragger
                                        name="file"
                                        accept=".xlsx"
                                        multiple={false}
                                        style={{
                                            marginTop: "8px",
                                            width: "100%",
                                            border: "1px solid rgb(0, 0, 0, 0.25)",
                                            borderRadius: "5px",
                                            background: "transparent",
                                        }}
                                        bordered={true}
                                        showUploadList={{
                                            showDownloadIcon: false,
                                        }}
                                        customRequest={({ file, onSuccess }) => {
                                            setTimeout(() => {
                                                onSuccess("ok");
                                            }, 0);
                                        }}
                                        onChange={(info) => {
                                            const { status } = info.file;
                                            if (status === "done") {
                                                setLanguageImportFile(info.fileList[0]?.originFileObj);
                                            } else if (status === "error") {
                                                message.error(`${info.file.name} file upload failed.`);
                                            }
                                        }}
                                        defaultFileList={languageImportFile ? [languageImportFile] : []}>
                                        <Row type="flex" justify="center" align="middle" style={{ flexDirection: "column" }}>
                                            <Icon
                                                type="cloud-upload"
                                                style={{
                                                    color: "#E5E5E5",
                                                    fontSize: "48px",
                                                    marginBottom: "24px",
                                                }}
                                            />
                                            <Text
                                                style={{
                                                    fontStyle: "normal",
                                                    fontWeight: "normal",
                                                    fontSize: "14px",
                                                    lineHeight: "22px",
                                                    color: "#181818",
                                                    marginBottom: 8,
                                                }}>
                                                Drag & drop file or browse file to upload
                                            </Text>
                                            <Text>Only XLSX file format is supported.</Text>
                                        </Row>
                                    </Dragger>
                                </div>
                            </React.Fragment>
                        </Row>
                    </div>

                    <div
                        style={{
                            marginTop: "24px ",
                            background: "#E8E8E8",
                            height: "1px",
                        }}></div>
                    <Row
                        type="flex"
                        justify="end"
                        align="middle"
                        style={{
                            marginTop: "32px",
                        }}>
                        <Button
                            size="large"
                            style={{
                                height: "40px",
                                boxShadow: "none",
                                borderRadius: "20px",
                                border: "none",
                                backgroundColor: "#FFFFFF",
                                color: "#181818",
                                marginRight: "12px",
                            }}
                            onClick={() => {
                                closeModal()
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            size="large"
                            style={{
                                height: "40px",
                                borderRadius: "5px",
                                border: "none",
                                backgroundColor: "#fec708",
                                color: "#FFFFFF",
                            }}
                            onClick={addLanguage}
                        disabled={ !languageImportFile }
                        >
                            Import File
                        </Button>
                    </Row>
                </Row>
            </Row>
        </div>
    )
}
